// useFetchNetworks.js
import axios from "axios";
import useGetImages from "./useGetImages";

const useGetNetworks = () => {
  //Hooks
  const { getImages } = useGetImages();

  const getNetworks = async () => {
    const response = await axios.get(
      window.location.origin +
        "/wp-json/wp/v2/produkter/natverk?_fields=title,acf,id,type,slug,featured_media&orderby=menu_order&order=asc&per_page=50"
    );

    //Extracting data from response
    const data = response.data;

    //Fetching images
    const imageArray = await getImages(data);

    //Remapping object
    const networks = [
      ...data.map((network, index) => ({
        id: network.id,
        slug: network.slug,
        type: network.type,
        title: network.title.rendered,
        image: imageArray[index],
        bredband: [...network.acf.bredband],
        bredband_tillbehor: [...network.acf.bredband_tillbehor],
        tv_kanal_paket: [...network.acf.tv_kanal_paket],
        tv_tillbehor: [...network.acf.tv_tillbehor],
        sakerhet: [...network.acf.sakerhet],
      })),
    ];

    return networks;
  };

  return { getNetworks };
};

export default useGetNetworks;
